import { render, staticRenderFns } from "./s04-documentation.vue?vue&type=template&id=e72351aa&scoped=true"
import script from "./s04-documentation.vue?vue&type=script&lang=js"
export * from "./s04-documentation.vue?vue&type=script&lang=js"
import style0 from "./s04-documentation.vue?vue&type=style&index=0&id=e72351aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72351aa",
  null
  
)

export default component.exports